module.exports = __webpack_public_path__ + "static/img/classifyBanner2.90e86cac.png";